/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 4/30/15.
 */

'use strict';

angular.module('prism-ui.components').controller('MessageModalController', function (_, $uibModalInstance, options) {
	this.messageText = options.messageText;
	this.modalTitle = options.title;
	this.showOK = options.showOK;
	this.okText = options.okText;
	this.cancelText = options.cancelText;
	this.windowClass = options.windowClass;
	this.optionsToPersist = options.optionsToPersist;
	this.pullCancelLeft = options.pullCancelLeft;
	this.showCancel = (_.has(options, 'showCancel')) ? options.showCancel : true;

	this.getLines = () => {
	    if (!Array.isArray(this.messageText)) {
	        return [this.messageText];
        } else {
	        return this.messageText;
        }
    };

	this.close = function () {
		$uibModalInstance.dismiss('cancel');
	};

	this.onOK = function () {
	    if (_.isNil(this.optionsToPersist)) {
            $uibModalInstance.close('OK');
        } else {
            $uibModalInstance.close(this.optionsToPersist);
        }
	};
});

// (EOF)
